import React from 'react';
import {withStyles} from "@material-ui/core"
import MaximiseIcon from "@material-ui/icons/Fullscreen";
import MinimiseIcon from "@material-ui/icons/FullscreenExit";
import Tooltip from "../../../components/common/StyledToolTip";
import  styles  from "./styles"

class Resize extends React.Component {
    constructor(props){
        super(props);
        this.state ={
           isMaximised: false
        }
    }

    componentDidUpdate(prevProps) {
      if (prevProps.isDefaultMaximize !== this.props.isDefaultMaximize) {
        if (
          (this.props.isDefaultMaximize && this.props.stack.isMaximised) ||
          (!this.props.isDefaultMaximize && !this.props.stack.isMaximised)
        ) {
          return;
        }
        this.toggleMaximise(); /* maximize/minimize only when it is not already maximize/minimize */
      }
    }

    toggleMaximise = () => {
        const {stack}=this.props;
        stack.toggleMaximise();
        this.setState({
          isMaximised: stack.isMaximised,
        });
        const freshDeskContainer = document.getElementById("freshworks-container");
        if (freshDeskContainer && !stack.layoutManager.isSubWindow) {
          freshDeskContainer.style.display = stack.isMaximised ? "none" : "block";
        }
        stack.layoutManager.eventHub.emit("mapResize");
    }

    render(){
        const { classes } = this.props;
        return (
            <div
            className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
            onClick={this.toggleMaximise}
          >
            <Tooltip title={this.state.isMaximised ? "Minimize" : "Maximize"}>
              {this.state.isMaximised ? <MinimiseIcon /> : <MaximiseIcon />}
            </Tooltip>
          </div>
       
        )
    }
}

export default withStyles(styles)(Resize);